import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IEntityApplicant } from 'app/models/applicants/entity-applicant';
import { Observable } from 'rxjs';

@Injectable({providedIn: 'root'})
export class EntityApplicantService {
  public api: string = environment.privateApi + 'EntityApplicant/';
  private http = inject(HttpClient);

  createApplicant(applicant: IEntityApplicant, licenseId: number): Observable<IEntityApplicant>{
    return this.http.post<IEntityApplicant>( this.api + 'CreateApplicant/' + licenseId, applicant);
  }

  updateApplicant(applicant: IEntityApplicant): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateApplicant', applicant);
  }

  getApplicants(entityId: number, includeArchived: boolean): Observable<IEntityApplicant[]>{
    return this.http.get<IEntityApplicant[]>(this.api + 'GetApplicants/' + entityId + '/' + includeArchived);
  }

  archiveApplicant(applicantId: number, archived: boolean): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'ArchiveApplicant/' + applicantId + '/' + archived, null);
  }

  deleteApplicant(applicantId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteApplicant/' + applicantId);
  }
}
